import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import { SiteLocale } from 'apps/website/types/dato';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { TBannerThemes, getBannerBackgroundColor, getButtonColor } from '../bannerThemes';

interface BannerControlsProps {
  isExpanded: boolean;
  hasOverflow: boolean;
  color: TBannerThemes;
  locale: SiteLocale;
  onExpandToggle: (expanded: boolean) => void;
  onClose: () => void;
}

const translateCloseBtn = {
  en: 'Close banner',
  fr: 'Fermer la bannière',
  es: 'Cerrar banner',
};

const translateExpandBtn = {
  en: {
    expand: 'Expand banner',
    collapse: 'Collapse banner'
  },
  fr: {
    expand: 'Développer la bannière',
    collapse: 'Réduire la bannière'
  },
  es: {
    expand: 'Expandir banner',
    collapse: 'Contraer banner'
  }
};

export const BannerControls: React.FC<BannerControlsProps> = ({
  isExpanded,
  hasOverflow,
  color,
  locale,
  onExpandToggle,
  onClose,
}) => (
  <>
    <button
      onClick={() => onExpandToggle(!isExpanded)}
      className={classNames(
        "absolute -z-20 bottom-[-28px] left-1/2 -translate-x-1/2 bg-transparent border-none cursor-pointer p-2 transition-all duration-300",
        hasOverflow ? "opacity-100" : "opacity-0 pointer-events-none"
      )}
      aria-label={translateExpandBtn[locale.toLowerCase() as keyof typeof translateExpandBtn][isExpanded ? 'collapse' : 'expand']}
    >
      <div className="relative w-[32px] h-[32px]">
        <div className={classNames(
          "absolute w-[32px] h-[32px] rounded-full top-[-6px] left-1/2 -translate-x-1/2"
        )} style={{ backgroundColor: getBannerBackgroundColor(color) }} />
        <Icon name="chevron" width={12} height={12} className={classNames(
          "w-[12px] h-[12px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 ease-in-out",
          isExpanded ? "rotate-0" : "rotate-180"
        )} style={{ color: getButtonColor(color) }} />
      </div>
    </button>

    <button
      className="absolute right-[8px] md:right-[16px] top-1/2 -translate-y-1/2 w-[32px] h-[32px] cursor-pointer flex items-center justify-center overflow-hidden"
      aria-label={translateCloseBtn[locale.toLowerCase() as keyof typeof translateCloseBtn]}
      onClick={onClose}
      style={{ color: getButtonColor(color) }}
    >
      <Icon name="clear" className="w-[24px] h-[24px]" style={{ color: getButtonColor(color) }} />
    </button>
  </>
); 